import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig } from '../config/filterConfig';

const BeneficiosFilter = ({
  loading,
  onApply,
  onLimpar
}) => {
  return <Row>
      <Col md={12}>
        <FilterPanel filters={filterConfig} onApply={onApply} onLimpar={onLimpar} title="Filtros de Benefícios" loading={loading} defaultCollapsed={true} />
      </Col>
    </Row>;
};

export default BeneficiosFilter;
